module.exports = __webpack_public_path__ + "img/globe_gray.6021eec2.svg";